import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "h-2/3" }
const _hoisted_2 = { class: "flex m-8" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Refresh List")
const _hoisted_4 = { class: "ml-4" }
const _hoisted_5 = {
  key: 0,
  class: "m-8 h-5/6"
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"grid grid-cols-4 pt-4 border-b-2\"><div class=\"p-4\">Status</div><div class=\"p-4\">Name</div><div class=\"p-4\">Operation Type</div><div class=\"p-4\">Date</div></div>", 1)
const _hoisted_7 = { class: "overflow-y-scroll h-5/6" }
const _hoisted_8 = { class: "p-4" }
const _hoisted_9 = { class: "p-4" }
const _hoisted_10 = { class: "p-4" }
const _hoisted_11 = { class: "p-4" }
const _hoisted_12 = {
  key: 1,
  class: "p-20"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_component = _resolveComponent("button-component")
  const _component_zero_landing_component = _resolveComponent("zero-landing-component")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_button_component, {
        class: "",
        onClick: _ctx.requestPublicJobs
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode("div", _hoisted_4, "Total Jobs: " + _toDisplayString(_ctx.cleanOperationsList.length), 1)
    ]),
    (_ctx.cleanOperationsList.length != 0)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _hoisted_6,
          _createVNode("div", _hoisted_7, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cleanOperationsList, (operation, index) => {
              return (_openBlock(), _createBlock("div", {
                class: "grid grid-cols-4 border-b-2",
                key: index
              }, [
                _createVNode("div", _hoisted_8, _toDisplayString(operation.payload.status), 1),
                _createVNode("div", _hoisted_9, _toDisplayString(operation.payload.name), 1),
                _createVNode("div", _hoisted_10, _toDisplayString(operation.payload.type), 1),
                _createVNode("div", _hoisted_11, _toDisplayString(operation.payload.date), 1)
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_12, [
          _createVNode(_component_zero_landing_component, {
            message: 'No Admin Backup Jobs Found',
            size: 'xl'
          })
        ]))
  ]))
}